// 所属の表示状態（external-design/registration.md「所属の状態」）。
// status は認可の 3 値、経過は時刻で持ち、表示はそこから導く。

export interface MembershipLike {
  status: "invited" | "active" | "disabled";
  invitedAt?: string | null;
  acceptedAt?: string | null;
  expiresAt?: string | null;
}

export type DisplayStatus = "ログイン前(招待未送信)" | "ログイン前(招待済)" | "受諾済み" | "期限切れ" | "ログイン済み" | "無効";

export function displayStatus(m: MembershipLike, now = new Date().toISOString()): DisplayStatus {
  if (m.status === "disabled") return "無効";
  if (m.status === "active") return "ログイン済み";
  if (!m.invitedAt) return "ログイン前(招待未送信)";
  if (m.expiresAt && m.expiresAt <= now) return "期限切れ";
  return m.acceptedAt ? "受諾済み" : "ログイン前(招待済)";
}
